module.exports = __webpack_public_path__ + "static/img/wasteL.5d8085c5.png";